import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool
import { templateConfig, reduxTemplateCofig } from './config'
let { WizBrowserExport } = component_tool

class PreAudit extends WizContainer {

    componentName = 'PreAudit'

    constructor(props) {
        super(props)
        this.state = {}
    }

    _handleCMD(nextProps, nextState, key) {
        let o = nextProps[key]
        if (o['success']) {
            wizNotice.success(o['msg'])
            return true
        } else {
            wizNotice.error(o['msg'])
            return false
        }
    }

    _handleFile(nextProps, nextState, key) {
        let { code, data, msg } = nextProps[key]
        if (code === 1) {
            let columns = [{
                headerName: '',
                width: 30,
                field: 'rowIndex',
                hidden: true,
                suppressMovable: true,
                cellStyle: {
                    textAlign: 'center',
                    padding: '5px 0',
                    color: '#595959',
                    backgroundColor: '#f0f0f0',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '500',
                    boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
                }
            }, {
                headerName: '品牌',
                field: 'orgName',
                width: 30,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '辅导模块',
                field: 'moduleType',
                width: 30,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '上传时间',
                field: 'uploadTime',
                width: 50,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '上传人',
                field: 'uploadFullName',
                width: 50,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }]

            let rows = data.map(item => {
                let { moduleType } = item
                item.moduleType = moduleType === 0 ? '销售' : '售后'
                return item
            })

            WizBrowserExport({
                title: '预审核标准',
                sheetName: '预审核标准',
                columns: columns.filter((_, index) => index),
                rows,
                filename: '预审核标准.xlsx',
            })
            return true
        } else {
            wizNotice.error(msg)
            return false
        }
    }

    _render() {
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig,
            apiDataFormat: {
                add: this._handleCMD,
                export: this._handleFile
            },
        })
        return <WizReduxTemplate {..._reduxTemplateCofig} />
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
}

export default connect(mapStateToProps)(PreAudit)
